import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { responseError, toastError, toastSuccess, user_id } from "../../../utils/constants";
import Pagination from "../../../utils/pagination";
import Header from "../../../common_components/Header";
import { get_application_query_list_action } from "../../../actions/adminModule_action/adminModule_action";
import moment from 'moment';
import { Modal } from "react-bootstrap";
import { insertUpdateJuryQuery_action } from "../../../actions/juryModule_action/jury_dashboard_action";
import Footer from "../../../common_components/Footer";
import MobileHeader from "../../../common_components/mobileHeader";
import { insertUpdateAwardAnswer_action } from "../../../actions/common_action/awardQuery_action";

class ApplicationQuery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isQueryOpen: false,
            user_id: "",
            jury_id: "",
            application_no: "",
            Description: "",
            StatusID: "",
            queryList: [],
            isAccordionExpanded: false,
            currentPage: 1,
            //query
            applicant_name: "", application_form_id: '',
            application_no: "", callback_date: "", callback_query: "",
            callback_time: "", jury_application_form_query_id: "", jury_id: '', qry_any_by: '',
            jury_name: "", qry_ans_by_id: '', qry_ans_date: null, qry_answer: null
        };
    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
            setTimeout(() => {
                this.props.navigate("/login");
            }, 500);
        }

        setTimeout(() => {
            {
                sessionStorage.getItem("role_id") == 2 ? (
                    this.props.navigate("/login")
                ) : <></>
            }
        }, 10);

        this.setState({
            user_id: sessionStorage.getItem("user_id") || "",
        });
        this.getQueryList();
    }

    getQueryList = () => {
        const { application_no } = this.state;
        this.setState({ isLoading: true });
        this.props.get_application_query_list_action(application_no)
            .then((data) => {
                if (data.error !== 1) {
                    this.setState({
                        queryList: data.data,
                        isLoading: false,
                        currentpage: 1,
                    });
                } else {
                    this.setState({ isLoading: false });
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }

    toggleOpenQuery(data) {
        this.setState({
            isQueryOpen: true,
            callback_query: data.callback_query,
            callback_date: data.call_back_time,
            callback_time: data.callback_time,
            jury_application_form_query_id: data.jury_application_form_query_id,
            jury_id: data.jury_id,
            qry_ans_by_id: data.qry_ans_by_id,
            qry_ans_date: data.qry_ans_date,
            application_form_id: data.application_form_id,
            questionTitle: data.questionTitle,
            answerContent: data.answerContent,
            question_id: data.question_id,
            answer_id: data.answer_id,
        })
    }
    toggleCloseQuery() {
        this.setState({
            isQueryOpen: false,
            callback_query: '',
            callback_date: '',
            callback_time: '',
            jury_application_form_query_id: '',
            jury_id: '',
            qry_ans_by_id: '',
            qry_ans_date: '',
            qry_answer: '',
            application_form_id: '',
            qry_any_by: '',
        })
    }
    submitQuery = () => {
        const {
            jury_application_form_query_id,
            application_form_id,
            qry_answer,
            callback_query,
            callback_date,
            callback_time
        } = this.state;

        // Validate input
        if (!qry_answer) {
            toastError('Please Enter Answer');
            return;
        }

        const isConfirm = window.confirm('Are you sure you want to submit this Answer?');
        if (!isConfirm) return;

        // Set loading state and prepare data for submission
        this.setState({ isLoading: true, qry_ans_by_id: user_id, qry_ans_date: new Date().toISOString() }, async () => {
            try {
                const { qry_ans_by_id, qry_ans_date } = this.state; // Get updated state values
                const data = await this.props.insertUpdateJuryQuery_action(
                    jury_application_form_query_id,
                    application_form_id,
                    qry_ans_by_id,
                    qry_answer,
                    qry_ans_date, // This will now be in ISO format
                    callback_query,
                    callback_date,
                    callback_time
                );

                // Handle response
                if (data.error !== 1) {
                    toastSuccess("Query Submitted Successfully");
                    this.setState({ isQueryOpen: false });
                } else {
                    responseError(data);
                }
            } catch (error) {
                console.error(error);
                toastError('An error occurred while submitting the query.');
            } finally {
                this.setState({ isLoading: false });
            }
        });
    }
    clearFilters = () => {
        this.setState({
            application_no: "",
        }, () => {
            this.getQueryList();
        });
    }

    updateItem = (item) => {
        this.setState({ currentPage: item });
    }
    replyQuery(question_id) {
        const {
            qry_answer,
            answer_id,
            award_event_id,
            award_event_profile_id,
            application_form_id,
        } = this.state;

        if (!qry_answer || qry_answer.trim() === '') {
            toastError("Kindly fill in the answer content");
            return;
        }

        this.props
            .insertUpdateAwardAnswer_action(
                question_id,
                answer_id,
                qry_answer,
                application_form_id,
                sessionStorage.getItem("user_name"),
                sessionStorage.getItem("email_address")
            )
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Reply submitted successfully!");
                    this.setState(
                        {
                            qry_answer: "",
                            isReplyMode: false,
                            question_id: "",
                        },
                        () => {
                            // Refresh list
                            this.getQueryList();
                            this.toggleCloseQuery();
                        }
                    );
                } else {
                    toastError(data.msg);
                }
            })
            .catch((e) => console.log(e));
    }

    queryRecords(queryList) {
        // const { userList } =this.state
        return (
            <table className="table table-bordered" id="dashboard-table" style={{ tableLayout: 'fixed', width: '100%' }}>
                <thead>
                    <tr>
                        <th>Application No</th>
                        <th>Query to</th>
                        <th>Query Type</th>
                        <th style={{ width: '30%' }}>Query</th>
                        <th>Query Datetime</th>
                        <th className="text-right" style={{ width: '10%' }}>Action</th>
                    </tr>
                </thead>
                <tbody id="myTable">
                    {queryList.length > 0 ? (
                        queryList.map((data) => {
                            const borderColor =
                                data.is_archived == 1
                                    ? "#ff4d4d" // 🔴 red for archived
                                    : data.is_seen == 0
                                        ? "#4a6fff" // 🔵 blue for unseen
                                        : "transparent";

                            return (
                                <tr key={data.question_id}>
                                    <td style={{
                                        color: "#062EC1", cursor: "pointer",
                                        borderLeft: `3px solid ${borderColor}`,
                                    }}>
                                        <a
                                            title="View Application"
                                            onClick={() =>
                                                this.props.navigate("/adminApplicationView", {
                                                    state: {
                                                        award_event_profile_id: data.award_event_profile_id,
                                                        application_form_id: data.application_form_id,
                                                    },
                                                })
                                            }
                                        >
                                            {data.application_no}
                                        </a>
                                    </td>
                                    <td>
                                        {data.query_to === 2
                                            ? "Jury"
                                            : data.query_to === 4
                                                ? "Applicant"
                                                : "Received"}
                                    </td>
                                    <td>{data.question_type}</td>
                                    <td
                                        style={{
                                            width: "30%",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                        title={data.questionTitle}
                                    >
                                        {data.questionTitle}
                                    </td>
                                    <td>{moment(data.created_date).format("DD/MM/YYYY - HH:mm")}</td>
                                    <td className="text-right">
                                        <a
                                            href="javascript:void(0);"
                                            title="Edit"
                                            className="btn btn-sm"
                                            onClick={() => this.toggleOpenQuery(data)}
                                        >
                                            <i className="ri-edit-box-line"></i>
                                        </a>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={6} className="text-center">
                                No records found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    render() {
        const {
            isLoading,
            queryList,
            currentPage,
            isAccordionExpanded,
            isQueryOpen,
            applicant_name, application_form_id,
            application_no, callback_date, callback_query,
            callback_time, jury_application_form_query_id, qry_any_by,
            jury_name, qry_ans_by_id, qry_ans_date, qry_answer
        } = this.state;
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        // Records to be displayed on the current page
        const currentRecords = queryList.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(queryList.length / recordsPerPage);

        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <>
                    <main id="main">

                        <div className="website-view">
                            <Header data={[8]} />
                        </div>
                        <div className="mobile-view">
                            <MobileHeader data={[8]} />
                        </div>
                        <section class='header_margin_top'>
                            <div className="container-fluid">
                                <div className="page-header">
                                    <h2 class="mb-3 dashboard-tit  py-0 blog-name blog-name-1">List of Queries</h2>
                                </div>
                                <div className="search_accordion search_card">
                                    <div className="panel-group" id="accordion">
                                        <div className="panel panel-default">
                                            <div
                                                className="panel-heading accordion-toggle collapsed"
                                                data-toggle="collapse"
                                                data-parent="#accordion"
                                                data-target="#collapseOne"
                                                aria-expanded={isAccordionExpanded}
                                                onClick={() =>
                                                    this.setState({
                                                        isAccordionExpanded: !isAccordionExpanded,
                                                    })
                                                }
                                            >
                                                <h4 className="panel-title">Search</h4>
                                                <div className="searched_items">
                                                    {application_no ? <>
                                                        <h5>
                                                            <b>Application No :</b> <span>{application_no}</span>
                                                        </h5>
                                                    </> : <></>}

                                                </div>
                                            </div>
                                            <div
                                                id="collapseOne"
                                                className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                                                    }`}
                                            >
                                                <div className="panel-body p-2">
                                                    <div className="row mr_0">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label>Application No</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control search_form_control"
                                                                    placeholder="Enter Name"
                                                                    value={application_no}
                                                                    onChange={(e) =>
                                                                        this.setState({ application_no: e.target.value })
                                                                    }
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <label>&nbsp;</label>
                                                            <button
                                                                onClick={() => this.getqueryList()}
                                                                className="btn btn-outline-primary search_btn"
                                                            >
                                                                Search
                                                            </button>
                                                            &nbsp;
                                                            <button
                                                                onClick={this.clearFilters}
                                                                className="btn btn-outline-danger clr_btn"
                                                            >
                                                                Clear
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="custom_table">
                                    <div className="hack1">
                                        <div className="hack2">
                                            {this.queryRecords(currentRecords)}
                                            {queryList.length > 0 ? (
                                                <Pagination
                                                    nPages={nPages}
                                                    currentPage={currentPage}
                                                    setCurrentPage={this.updateItem}
                                                />
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <Footer />

                    </main>
                    <Modal show={isQueryOpen} size="lg" onHide={() => this.toggleCloseQuery()}>
                        <Modal.Body>
                            <div className="container-fluid">
                                <div className="page-header d-flex justify-content-between align-items-center">
                                    <h4 className="page-title mb-0">Resolve Query</h4>
                                    <h1
                                        className="Services_Active_or_Not"
                                        style={{
                                            fontSize: "25px",
                                            fontWeight: "800",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => this.toggleCloseQuery()}
                                    >
                                        X
                                    </h1>
                                </div>
                            </div>

                            <div className="container-fluid">
                                <div className="outside_input_field mt-3">
                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "25%" }}>Query</td>
                                                <td>{this.state.answer_id ? this.state.answerContent : this.state.questionTitle}</td>
                                            </tr>
                                            <tr>
                                                <td>Call Back</td>
                                                <td>
                                                    {callback_date
                                                        ? moment(callback_date).format("HH:mm - DD/MM/YYYY")
                                                        : ""}{" "}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Answer</td>
                                                <td>
                                                    <textarea
                                                        rows={4}
                                                        value={qry_answer}
                                                        className="form-control"
                                                        placeholder="Enter your answer..."
                                                        onChange={(e) =>
                                                            this.setState({ qry_answer: e.target.value })
                                                        }
                                                    ></textarea>
                                                </td>
                                            </tr>

                                            {/* {parseInt(qry_ans_by_id) !== 0 && (
                                                <>
                                                    <tr>
                                                        <td>Answered By</td>
                                                        <td>{qry_any_by}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Answered Date</td>
                                                        <td>
                                                            {qry_ans_date
                                                                ? moment(qry_ans_date).format("DD/MM/YYYY")
                                                                : ""}
                                                        </td>
                                                    </tr>
                                                </>
                                            )} */}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <button
                                className="btn btn-warning btn-sm"
                                onClick={() => this.replyQuery(this.state.question_id)}
                            >
                                Submit
                            </button>
                            <button
                                className="btn btn-dark btn-sm"
                                onClick={() => this.toggleCloseQuery()}
                            >
                                Close
                            </button>
                        </Modal.Footer>
                    </Modal>


                    <ToastContainer />
                </>
            </>
        );
    }
}
const mapDispatchToProps = {
    get_application_query_list_action, insertUpdateJuryQuery_action, insertUpdateAwardAnswer_action
};

export default withRouter(
    connect(null, mapDispatchToProps)(ApplicationQuery)
);
